import * as React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import type { RouteObject } from "react-router-dom";

import { Page as NotFoundPage } from "@/pages/not-found";
import { IN_SMB } from "@/lib/platform";
import { AuthGuard } from "@/components/auth/auth-guard";

import { route as authRoute } from "./auth";
import { route as dashboardRoute } from "./dashboard";
import { route as oauthRoute } from "./oauth";
import { onboardingRoute, route as smbRoute } from "./smb";

const notFoundRoute: RouteObject = {
	path: "*",
	element: (
		<AuthGuard>
			<NotFoundPage />
		</AuthGuard>
	),
};

// The business app used to live under /smb. The API still returns from Stripe to /smb/billing,
// and the old addresses are in bookmarks and emails.
function FormerSmbPath(): React.JSX.Element {
	const { "*": rest = "" } = useParams();
	const { search, hash } = useLocation();
	return <Navigate replace to={{ pathname: `/${rest}`, search, hash }} />;
}

/** The business app: the root of a self-service deployment. */
const smbRoutes: RouteObject[] = [
	authRoute,
	oauthRoute,
	smbRoute,
	onboardingRoute,
	{ path: "smb/*", Component: FormerSmbPath },
	notFoundRoute,
];

/** The dashboard: all of an enterprise deployment, and /admin of a self-service one. */
const dashboardRoutes: RouteObject[] = [authRoute, oauthRoute, dashboardRoute, notFoundRoute];

export const routes: RouteObject[] = IN_SMB ? smbRoutes : dashboardRoutes;
